import Loading from 'components/commons/loading/Loading';
import Modal from 'components/commons/modal/Modal2';
import React from 'react';

type Props = {
  isShow: boolean;
  hide: () => void;
  endTarget: () => Promise<void>;
};

export const EndTargetModal = ({
  isShow,
  hide,
  endTarget,
}: Props): React.ReactElement => {
  const onClick = async (): Promise<void> => {
    setAPIState('hitting');
    endTarget();
  };
  const [apiState, setAPIState] = React.useState<'ready' | 'hitting'>('ready');
  return (
    <>
      <Modal {...{ isShow, close: hide }}>
        <div className={`p-4 max-h-modal overflow-y-auto`}>
          <div className={`flex flex-row justify-between`}>
            <div className={`font-bold text-base text-bluegray-700`}>
              この目標を終了しますか？
            </div>
            <div
              className={`icon-close text-bluegray-500 text-lg cursor-pointer`}
              onClick={hide}></div>
          </div>
          <div className={`mt-3 text-sm text-bluegray-700`}>
            <div className={``}>
              削除後は目標の達成状況やアドバイスは見ることができなくなります。
            </div>
            <div className={``}>この目標を削除してよろしいですか？</div>
          </div>
          <button
            className={`mt-4 rounded-lg flex flex-row items-center justify-center p-2 ${
              apiState === 'hitting' ? 'bg-red-50' : 'bg-tradewell'
            } w-full text-white font-bold`}
            onClick={onClick}>
            {((): React.ReactElement => {
              switch (apiState) {
                case 'ready':
                  return <>削除する</>;
                case 'hitting':
                  return (
                    <>
                      <Loading loading circularLoading />
                    </>
                  );
              }
            })()}
          </button>
          <button
            className={`flex flex-row items-center justify-center p-2 mt-3 w-full text-bluegray-700`}
            onClick={hide}>
            キャンセル
          </button>
        </div>
      </Modal>
    </>
  );
};
